import {
  paths,
  knowledgeProductsOverviewResponseSchema,
  type KnowledgeProductsOverviewResponse,
} from "@go-novus/admin-api";

import {
  requestBackendResult,
  type BackendFailure,
} from "#/shared/lib/backend-api";
import type { ResultAsync } from "#/shared/lib/result";

/** 商品概览仅使用 Shopify 数据。 */
export const getKnowledgeOverviewOperation = "knowledge.overview";

export type GetKnowledgeOverviewOperation =
  typeof getKnowledgeOverviewOperation;

export type GetKnowledgeOverviewFailure =
  BackendFailure<GetKnowledgeOverviewOperation>;

export function getKnowledgeOverview(
  options: { fetch?: typeof globalThis.fetch; signal?: AbortSignal } = {},
): ResultAsync<KnowledgeProductsOverviewResponse, GetKnowledgeOverviewFailure> {
  return requestBackendResult({
    fetch: options.fetch,
    method: "GET",
    operation: getKnowledgeOverviewOperation,
    parse: (payload) => knowledgeProductsOverviewResponseSchema.parse(payload),
    path: `${paths.knowledgeOverview}?section=products`,
    signal: options.signal,
  });
}
